import { AuthShell, ResetPasswordForm, buttonVariants, cn } from "@nexys/user-management-web";
import { Link, useSearchParams } from "react-router-dom";

/** Landing page for the emailed reset link: /reset-password?token=… */
export const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";

  return (
    <AuthShell brand="UM-RS Console">
      {token ? (
        <ResetPasswordForm
          token={token}
          successSlot={
            <Link to="/sign-in" className={cn(buttonVariants(), "w-full")}>
              Go to sign in
            </Link>
          }
        />
      ) : (
        <div className="grid max-w-md gap-3 text-center">
          <h1 className="text-2xl font-semibold">Invalid reset link</h1>
          <p className="text-sm text-muted-foreground">
            This link is missing its token. Request a new reset email and use
            the link it contains.
          </p>
          <Link to="/forgot-password" className="text-primary hover:underline">
            Request a new link
          </Link>
        </div>
      )}
    </AuthShell>
  );
};
